import React, { useState } from "react";

import ReusableForm from "../../../../../common/ReusableForm";
import { Typography } from "@mui/material";
import { createInstituteProfessorColums } from "../../../../../../utils/tableConfig";

const AddProfessor = ({
  handleSubmit,
  handleCloseModal,
  handleInputChange,
  data,
  isDisabled,
  formError,
  isLoading,
}) => {
  return (
    <>
      <Typography variant="h6" gutterBottom>
        Add New Professor
      </Typography>
      <ReusableForm
        type="add"
        fields={createInstituteProfessorColums}
        handleChange={handleInputChange}
        handleSubmit={handleSubmit}
        errors={formError}
        formData={data}
        handleCloseModal={handleCloseModal}
        isApiLoading={isLoading?.isLoading}
      />
    </>
  );
};

export default AddProfessor;
